<div class="bg-white pt--24 pt--lg-64 pb-24 pb--lg-64" *ngIf="showIntro">
    <div class="container">
        <div class="pt--48 pb--48 text-center">
            <app-section-title [title]="'page.report.promo_section_title' | translate">
            </app-section-title>
        </div>
        <div class="row">
            <div class="col-12 col-md-6 col-lg-6 d-flex flex-column justify-content-center">
                <!-- <app-section-title [title]="'page.report.promo_section_title' | translate"
                [titletag]="'page.report.promo_section_titletag' | translate">
            </app-section-title> -->
                <div class="mat-subtitle-2" [innerHTML]="'page.report.section_features_description' | translate"></div>
                <div class="actions d-flex flex-column flex-lg-row pt--24 pb--24 gap-16">
                    <!-- <button mat-stroked-button color="primary" >{{ 'Read more' | translate }}</button> -->
                    <button mat-flat-button color="primary" (click)="showPlans()" translate>{{ 'Get a Benchamark now' |
                        translate }}</button>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6">
                <img [ngSrc]="'/images/benchmark-delfi-cell.webp'" width="709" height="560" alt="Features"
                    class="img-responsive rounded">
            </div>
        </div>
    </div>
</div>
<!-- <div class="pt--96 pb--96 text-center">
    <app-section-title [title]="'page.report.section_features_title' | translate"
        [titletag]="'page.report.section_features_titletag' | translate">
    </app-section-title>
</div> -->
<!-- <swiper-container
  space-between="20"
  loop="true"
  navigation
  pagination
  slides-per-view="3">
    <swiper-slide *ngFor ="let feature of featuresBlock">
        <div class="feature">
        <img [ngSrc]="feature.image" *ngIf="feature.image" width="709" height="560" alt="{{ feature.image }}" class="img-responsive rounded img-features">
        <div class="feature-description">
            <div class="mat-subtitle-2 text-primary mb--8 mb--lg-16" [innerHTML]="feature.subtitle | translate"></div>
            <h3 class="section-title" [innerHTML]="feature.title | translate"></h3>
            <div class="mt--24 mat-subtitle-2" [innerHTML]="feature.content | translate"></div>
        </div>
     </div>
    </swiper-slide>
  </swiper-container> -->
<ng-container *ngIf="showFeatures && featuresBlock">
    <ng-container [ngSwitch]="featureMode">
        <ng-container *ngSwitchCase="'carousel'">
            <app-carousel [items]="featuresBlock"></app-carousel>
        </ng-container>
        <ng-container *ngSwitchCase="'list'">
            <ng-container *ngTemplateOutlet="feturesList; context: {$implicit: featuresBlock}"></ng-container>
        </ng-container>
        <ng-container *ngSwitchDefault>
            <ng-container *ngTemplateOutlet="feturesList; context: {$implicit: featuresBlock}"></ng-container>
        </ng-container>
    </ng-container>
</ng-container>

<ng-template #feturesList let-featuresBlock>
    <div class="container pt--lg-64 pb--lg-64 pt--24 pb--24">
        <div class="row pt--24 pb--24 pt--lg-72 pb--lg-72 " *ngFor="let feature of featuresBlock; let index = index"
            [ngClass]="{'row-reverse': index % 2 }">
            <div class="col-12 col-md-6 col-lg-6">
                <img [ngSrc]="feature.image" *ngIf="feature.image" width="709" height="560" alt="{{ feature.image }}"
                    class="img-responsive rounded img-features">
            </div>
            <div class="col-12 col-md-6 col-lg-6">
                <div class="mat-subtitle-2 text-primary mb--8 mb--lg-16" [innerHTML]="feature.subtitle | translate">
                </div>
                <h3 class="section-title" [innerHTML]="feature.title | translate"></h3>
                <div class="mt--24 mat-subtitle-2" [innerHTML]="feature.content | translate"></div>
                <div class="actions pt--24 pb--24">
                    <button mat-flat-button color="primary" (click)="showPlans()" translate>{{ 'Get your Benchamark' |
                        translate }}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>